import { css } from '@emotion/css';

export const container = css`
  --rsbs-max-w: auto;
  --rsbs-ml: env(safe-area-inset-left);
  --rsbs-mr: env(safe-area-inset-right);
  --rsbs-overlay-rounded: 16px;

  @media (min-width: 640px) {
    --rsbs-max-w: 640px;
    --rsbs-ml: auto;
    --rsbs-mr: auto;
  }
`;

export const bottomSheetSibling = css`
  &[data-rsbs-backdrop] {
    z-index: 3;
  }

  .bottomSheet {
    [data-rsbs-overlay] {
      z-index: 10;
    }

    [data-rsbs-backdrop]:not(:first-child) {
      display: none;
    }
  }
`;
